import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import styles from "./styles";
import { withStyles, Button, Typography } from "@material-ui/core";
import MembershipModal from "../../components/membershipModal";
import { openSnackBar } from "../../actions/snack-bar";
import { checkSubscription } from "../../actions/subscribe";

class Checkout extends React.Component {
  state = {
    payModal: true,
  };

  async componentDidMount() {
    console.log("Set Mounting");
    const user = this.props.authentication.authenticatedUser;
    await this.props.dispatch(checkSubscription(user.id)).then((res) => {
      if (!res.message && !res.is_premium) {
        console.log("this is the message:");
        console.log(res.is_premium);
        console.log(res.message);
        console.log(res.is_premium);
        this.setState({ payModal: true });
      } else {
        console.log("this is the message:");
        console.log(res.message);
        console.log(res.is_premium);
        // res.next * 1000 is used to convert timestamp into milliseconds
        if (res.ending && res.next * 1000 < new Date().getTime()) {
          this.setState({ payModal: true });
        } else {
          this.setState({ payModal: false });
        }
      }
    });
  }

  render() {
    const { authentication = {}, history } = this.props;

    const {
      first_name = "",
      last_name = "",
      id: myID,
    } = authentication.authenticatedUser;

    return (
      <div>
        {this.state.payModal ? (
          <MembershipModal
            onClose={() => this.setState({ payModal: false, isSent: false })}
            onFailure={() => {
              this.setState({ payModal: false, isSent: false });
              this.props.dispatch(
                openSnackBar({ message: "Error Purchasing Membership" })
              );
            }}
            onSuccess={() => {
              this.props.history.push("/magic");
              this.setState({ payModal: false });
              this.props.dispatch(
                openSnackBar({ message: "Membership Purchased" })
              );
              this.setState({ isSent: false });
            }}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return { authentication: store.authentication };
};

export default compose(connect(mapStateToProps), withStyles(styles))(Checkout);
